<template>
  <div :class="componentClassName">
    <a-page-heading>営業時間設定</a-page-heading>
    <m-section variant="fullpage">
      <m-action-card
        :title="`${numberName}（${telNumber}）の休憩時間の対応`"
        icon="calendar"
        :header-border="true"
        :narrow-body="true"
      >
        <form
          ref="form"
          class="t-setting-business-hours-edit-hours-on-holiday-response__form"
          @submit.prevent="handleFormSubmit"
        >
          <div class="t-setting-business-hours-edit-hours-on-holiday-response__fields">
            <m-form-input label="対応方法">
              <a-select-field id="responseModeOptions" v-model="currentResponseMode" :options="responseModeOptions" />
            </m-form-input>

            <m-automatic-responder-setting
              v-model:voice="currentVoice"
              v-model:content="currentContent"
              v-model:phone-number="currentPhoneNumber"
              v-model:absence-mail="currentAbsenceMail"
              v-model:email-notification="currentEmailNotification"
              :voice-d-x-phone-number-list="voiceDXPhoneNumberList"
              :response-mode="responderResponseMode"
              :voice-list="voiceList"
              :show-email="false"
              :voice-guidance-place-holder="currentVoiceGuidancePlaceHolder"
              :voice-guidance-no-message-place-holder="currentVoiceGuidanceNoMessagePlaceHolder"
              :is-voice-playing="isVoicePlaying"
              @play="handlePlayVoice"
              @stop="handleStopVoice"
            />
            <m-form-action-buttons>
              <a-button id="store" variant="block" color="primary" :disabled="savaButtonDisable" submit="submit">
                保存
              </a-button>
              <a-button id="cancel" variant="outlined" color="primary" @click="handleCancelClick">キャンセル</a-button>
            </m-form-action-buttons>
          </div>
        </form>
      </m-action-card>
    </m-section>
  </div>
  <teleport to="body">
    <o-modal
      id="settingBreakTime_resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
      <span v-html="resultModalContent" />
      <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MActionCard from '@/components/molecules/action-card';
import MSection from '@/components/molecules/section';
import MAutomaticResponderSetting from '@/components/molecules/automatic-responder-setting';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import AButton from '@/components/atoms/button';
import MFormInput from '@/components/molecules/form-input';
import ASelectField from '@/components/atoms/select-field';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';
import { POINT } from '@/libs/constants';

// For Trial
import { utils } from '@/common/utils.js';

export default {
  name: 't-setting-break-time-edit-hours-response',
  components: {
    APageHeading,
    MActionCard,
    MSection,
    MAutomaticResponderSetting,
    MFormActionButtons,
    AButton,
    MFormInput,
    ASelectField,
  },
  mixins: [customRequest, customValidate],
  props: {
    class: {
      type: String,
      default: '',
    },
    companyID: {
      type: String,
      default: '',
    },
    setLoading: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      responseModeOptions: [
        {
          label: 'ガイダンスを流して留守電',
          value: 'voice-guidance',
        },
        {
          label: 'ガイダンスを流して切断',
          value: 'voice-guidance-no-message',
        },
        {
          label: '外線転送',
          value: 'transfer',
        },
      ],
      voiceDXPhoneNumberList: [],
      // currentResponseMode: 'voice-guidance-no-message',
      currentResponseMode: null,
      currentVoice: null,
      currentContent: null,
      breakTimeGuidance1: null,
      breakTimeGuidance2: null,
      currentPhoneNumber: null,
      currentAbsenceMail: '',
      currentEmailNotification: false,
      voiceList: [
        {
          value: '1',
          label: '日本語 | 女性 | 大人 | 02',
        },
      ],
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      selectedCompanyID: '',

      //音声
      audio: null,
      isVoicePlaying: false,

      phone_number: this.$store.state.user.phoneNumber ? this.$store.state.user.phoneNumber : '',
      savaButtonDisable: false,
      using050Numbers: [],
      telNumber: '',
      numberName: '',
      saveSuccessFlag: false, // 保存成功フラグ
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-setting-break-time-hours-edit-hours-on-holiday-response');
      return `${baseClassName} ${this.class}`.trim();
    },
    responderResponseMode() {
      return this.currentResponseMode;
    },
    dbResponseMode() {
      if (this.currentResponseMode === 'voice-guidance') {
        return 'voiceMessage';
      }
      if (this.currentResponseMode === 'voice-guidance-no-message') {
        return 'onlyGuidance';
      }
      return 'transferCall';
    },
    isGuidance() {
      return this.currentResponseMode === 'voice-guidance' || this.currentResponseMode === 'voice-guidance-no-message';
    },
    currentVoiceGuidancePlaceHolder() {
      return messageContent.breakTimeHoursVoiceGuidanceNoMessagePlaceHolder;
    },
    currentVoiceGuidanceNoMessagePlaceHolder() {
      return messageContent.breakTimeHoursVoiceGuidanceNoMessagePlaceHolder;
    },
  },
  watch: {
    currentResponseMode(val, oldVal) {
      if (oldVal === 'voice-guidance-no-message') {
        this.breakTimeGuidance1 = this.currentContent;
      } else if (oldVal === 'voice-guidance') {
        this.breakTimeGuidance2 = this.currentContent;
      }
      if (val === 'voice-guidance-no-message') {
        this.currentContent = this.breakTimeGuidance1;
      } else if (val === 'voice-guidance') {
        this.currentContent = this.breakTimeGuidance2;
      } else if (val === 'transfer') {
        if (oldVal === 'voiceDX') {
          this.currentPhoneNumber = this.transferPhoneNumber;
        }
      } else if (val === 'voiceDX') {
        const oldCurrentPhoneNumber = this.currentPhoneNumber;
        this.currentPhoneNumber = '';
        for (const key in this.voiceDXPhoneNumberList) {
          // プルダウン値を選択状態にする
          if (oldCurrentPhoneNumber === this.voiceDXPhoneNumberList[key].value) {
            this.currentPhoneNumber = this.voiceDXPhoneNumberList[key].value;
          }
        }
      }
    },

    $route(to, from) {
      if (this.audio && this.audio.state === 'running') this.audio.close();
    },
  },
  created() {
    if (this.$route.query.companyID) {
      this.selectedCompanyID = this.$route.query.companyID;
    }
    this.telNumber = this.$route.params.telNumber;
    this.numberName = this.$route.params.numberName;
    if (!this.telNumber || !this.numberName) {
      this.$router.push({
        name: 'ServiceConditionList',
        // ページは連続に遷移するのでCSRFトークンをリフレッシュする（/authenticate）のはスキップとする。
        params: { skipResfreshCSRFToken: true, isAuthenticated: true },
      });
      return;
    }
    this.preloadData();
  },
  mounted() {
    if (utils.chkTrialCompanyID(this.companyID) || utils.chkTrialCompanyID(this.selectedCompanyID)) {
      this.savaButtonDisable = true;
      this.showInfoModal(messageContent.notifyTrialUserCanNotSaveBusinessHours('休憩時間の対応設定'));
    }
  },
  methods: {
    preloadData() {
      this.postRequest('/servicecondition/break-time-hours-guidance-preload-data', {
        companyID: this.companyID === POINT ? this.selectedCompanyID : this.companyID,
        telNumber: this.telNumber,
      })
        .then(res => {
          this.currentResponseMode = res.data.mode;
          this.breakTimeGuidance1 = res.data.breakTimeGuidance1;
          this.breakTimeGuidance2 = res.data.breakTimeGuidance2;
          this.currentAbsenceMail = res.data.absenceMail;
          this.currentEmailNotification = res.data.emailNotification;
          this.currentPhoneNumber = res.data.phoneNumber;
          this.voiceDXPhoneNumberList = res.data.voiceDXData;
          if (this.voiceDXPhoneNumberList.length !== 0) {
            this.responseModeOptions = [
              {
                label: 'ガイダンスを流して留守電',
                value: 'voice-guidance',
              },
              {
                label: 'ガイダンスを流して切断',
                value: 'voice-guidance-no-message',
              },
              {
                label: '外線転送',
                value: 'transfer',
              },
              {
                label: 'COTOHA Voice DX Basic',
                value: 'voiceDX',
              },
            ];
          }
          this.using050Numbers = res.using050Numbers;
        })
        .catch(err => {
          this.showErrorModal(messageContent.requireTry('休憩時間の取得'));
        });
    },
    async handleFormSubmit(e) {
      e.preventDefault();
      const payload = {
        mode: this.dbResponseMode,
      };
      if (this.isGuidance) {
        payload.voice = this.currentVoice;
        payload.content = this.currentContent;
        payload.absenceMail = this.currentAbsenceMail;
        payload.emailNotification = this.currentEmailNotification;
      } else {
        payload.phone_number = this.currentPhoneNumber;
      }
      if (this.validateForm(payload)) {
        this.setLoading(true);
        //COTOHA音声を作成
        if (this.isGuidance && payload.content && payload.content.trim()) {
          const self = this;
          const breakTimeGuidance = {};
          const key = this.responderResponseMode === 'voice-guidance' ? 'breakTimeGuidance2' : 'breakTimeGuidance1';
          breakTimeGuidance[key] = payload.content;
          this.postRequest('/servicecondition/cotohattsupload', {
            data: breakTimeGuidance,
            companyID: this.selectedCompanyID,
            selectedPhoneNumber: this.telNumber,
          })
            .then(async data => {
              if (data.status === 'success') {
                payload.breakTimeGuidanceURL = data.data.guidanceURL ? data.data.guidanceURL[`${key}URL`] : '';
                payload.content = payload.content.replace(/\n/g, '%%n%%');
                await self.handleSaveClick(payload);
              } else {
                self.showErrorModal(messageContent.requireTry('音声作成'));
              }
              this.setLoading(false);
            })
            .catch(error => {
              self.showErrorModal(messageContent.requireTry('音声作成'));
              this.setLoading(false);
            });
        } else {
          if (payload.content && payload.content.trim()) {
            payload.content = payload.content.replace(/\n/g, '%%n%%');
          }
          await this.handleSaveClick(payload);
          this.setLoading(false);
        }
      }
    },
    validateForm(formData) {
      // if (this.responderResponseMode === 'voice-guidance') {
      if (this.isGuidance) {
        // Check special characters
        if (this.hasSpecialCharacterInObject(formData)) {
          this.showErrorModal(messageContent.hasSpecialCharacter);
          return false;
        }
        // Guidance is not null
        if (!formData.content) {
          this.showErrorModal(messageContent.guidanceRequired);
          return false;
        }
        // Only space check
        const onlySpaceChk = this.onlySpaceCheck(formData.content, 'ガイダンス内容');
        if (!onlySpaceChk.status) {
          this.showErrorModal(onlySpaceChk.message);
          return false;
        }
        const lengthCheck = this.guidanceLengthCheck(formData.content);
        if (!lengthCheck.status) {
          this.showErrorModal(lengthCheck.message);
          return false;
        }
        const charCheck = this.guidanceCharCheck(formData.content);
        if (!charCheck.status) {
          this.showErrorModal(charCheck.message);
          return false;
        }
        // Validate email
        if (formData.emailNotification) {
          const lengthCheck = this.emailLengthCheck(formData.absenceMail);
          if (!lengthCheck.status) {
            this.showErrorModal(lengthCheck.message);
            return false;
          }
          if (!this.addressCheck(formData.absenceMail)) {
            this.showErrorModal(messageContent.incorrectEmailFormat);
            return false;
          }
        }
      } else if (this.responderResponseMode === 'transfer') {
        // Validate phone number
        if (formData.phone_number.length !== 11 && formData.phone_number.length !== 10) {
          this.showErrorModal(messageContent.invalidDigitsNumberOfPhoneNumber);
          return false;
        }
        if (!this.numberOnly(formData.phone_number)) {
          this.showErrorModal(messageContent.phonenumberIsNotHalfWidth);
          return false;
        }
        if (this.using050Numbers.includes(formData.phone_number)) {
          this.showErrorModal(messageContent.notSetTransferNumber);
          return false;
        }
      } else {
        if (!this.voiceDXPhoneNumberList.some(v => v.value === formData.phone_number)) {
          this.showErrorModal(messageContent.requirePhonenumberOfVDXB);
          return false;
        }
      }
      return true;
    },
    async handleSaveClick(formData) {
      await this.postRequest('/servicecondition/save-break-time-hours-guidance', {
        formData,
        telNumber: this.telNumber,
        companyID: this.companyID === POINT ? this.selectedCompanyID : this.companyID,
      })
        .then(res => {
          if (res.status === 'success') {
            this.showUpdateInfoModal(messageContent.breakTimeSettingCompleted);
          } else {
            this.showErrorModal(messageContent.updateSettingError);
          }
        })
        .catch(err => {
          if (err === 404) return this.showErrorModal(messageContent.noOperationPermission);
          return this.showErrorModal(messageContent.settingSavingError);
        });
    },
    handleCancelClick() {
      if (this.companyID === POINT) {
        this.$router.push({
          path: '/service-condition',
          query: { companyID: this.$route.query.companyID, telNumber: this.telNumber },
        });
      } else {
        this.$router.push({ path: '/service-condition', query: { telNumber: this.telNumber } });
      }
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
      if (this.saveSuccessFlag) {
        // 正常保存の場合、営業時間設定画面に遷移
        this.handleCancelClick();
      }
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
      this.saveSuccessFlag = false;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
      this.saveSuccessFlag = false;
    },
    showUpdateInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
      this.saveSuccessFlag = true;
    },
    async handlePlayVoice(data) {
      if (!data.content) {
        this.showErrorModal(messageContent.emptyGuidanceError);
        return;
      }
      if (data.content && this.hasSpecialCharacterInObject(data.content)) {
        this.showErrorModal(messageContent.hasSpecialCharacter);
        return;
      }
      const lengthCheck = this.guidanceLengthCheck(data.content);
      if (!lengthCheck.status) {
        this.showErrorModal(lengthCheck.message);
        return;
      }
      const charCheck = this.guidanceCharCheck(data.content);
      if (!charCheck.status) {
        this.showErrorModal(charCheck.message);
        return;
      }
      if (this.audio && this.audio.state === 'running') this.audio.close();
      this.isVoicePlaying = true;
      const self = this;
      await this.postRequest('/servicecondition/testvoice', {
        content: data.content,
        selectedCompanyID: this.selectedCompanyID,
        selectedPhoneNumber: this.telNumber,
      })
        .then(async data => {
          if (data.status === 'success' && data.data.voiceBufferData) {
            self.audio = null;
            self.audio = new AudioContext();
            const arr = Uint8Array.from(data.data.voiceBufferData.data);
            const audio = await self.audio.decodeAudioData(arr.buffer);
            const source = self.audio.createBufferSource();
            source.buffer = audio;
            source.connect(self.audio.destination);
            source.start(0);
            source.onended = function () {
              self.isVoicePlaying = false;
            };
          } else {
            this.isVoicePlaying = false;
            self.showErrorModal(messageContent.playbackError);
          }
        })
        .catch(error => {
          this.isVoicePlaying = false;
          self.showErrorModal(messageContent.playbackError);
        });
    },
    handleStopVoice() {
      if (this.audio && this.audio.state === 'running') {
        const self = this;
        this.audio.close().then(function () {
          self.isVoicePlaying = false;
        });
      }
    },
  },
};
</script>
